import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=5de85536&scoped=true&"
import script from "./ManageProduct.vue?vue&type=script&lang=js&"
export * from "./ManageProduct.vue?vue&type=script&lang=js&"
import style0 from "./ManageProduct.vue?vue&type=style&index=0&id=5de85536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de85536",
  null
  
)

export default component.exports